import * as Yup from 'yup';
import {
  Button, Chip, Grid, TextField
} from '@material-ui/core';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TableNavigationGoToPage = ({ curPage, maxPage, onPageChange }) => {
  const [page, setPage] = useState(curPage);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const schema = Yup.object().shape({
    page: Yup.number().max(maxPage).min(0).required()
  });

  const handleSubmit = async () => {
    const valid = await schema.isValid({
      page,
    });

    if (!valid) {
      setError(true);
      return;
    }

    setError(false);
    setLoading(true);
    await onPageChange(parseInt(page));
    setLoading(false);
  }

  return (
    <form onSubmit={async(e) => {
      e.preventDefault();
      await handleSubmit();
    }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Chip label={`Página ${curPage} de ${maxPage}`} />
        </Grid>
        <Grid item>
          <TextField
            error={error}
            label="Página"
            type="number"
            value={page}
            onChange={(e) => setPage(e.target.value)}
            size="small"
            margin="dense"
          />
        </Grid>
        <Grid item padding="dense">
          <Button type="submit" disabled={loading}>
            Ir à página
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

TableNavigationGoToPage.propTypes = {
  curPage: PropTypes.number,
  maxPage: PropTypes.number,
  onPageChange: PropTypes.func
};

export default TableNavigationGoToPage;
